import { motion, AnimatePresence } from "motion/react";
import styles from "./EvaluationFooter.module.css";
import tickIcon from "@assets/icons/charm-tick.svg";
import { EVALUATION_TYPES } from "@constants/evaluationConstants";
import { useShortcut } from "@hooks/useShortCut";

interface EvaluationFooterProps {
  questionIndex?: number;
  totalQuestions: number;
  approvalValid: boolean;
  evaluationType?:string;
  onPrevious?: () => void;
  onApproveAndSubmit: () => void;
  onApproveAndNext?: () => void;
  disableApproveAndSubmit?:boolean;
  isSaving?:boolean;
}

function EvaluationFooter({
  questionIndex=0,
  totalQuestions,
  approvalValid,
  evaluationType,
  onPrevious,
  onApproveAndSubmit,
  onApproveAndNext,
  disableApproveAndSubmit,
  isSaving
}: EvaluationFooterProps) {
  const isLastQuestion = questionIndex === totalQuestions - 1;
  const showApproveNext =
  (!isLastQuestion && !!onApproveAndNext) ||
  evaluationType === EVALUATION_TYPES.QUESTION_WISE_EVALUATION;
  const showApproveSubmit = isLastQuestion;
  useShortcut("Ctrl+Enter", () => {
    if (!approvalValid) return;

    // Priority 1: Approve & Next
    if (showApproveNext && onApproveAndNext) {
      onApproveAndNext();
      return;
    }

    // Priority 2: Approve & Submit
    if (showApproveSubmit) {
      onApproveAndSubmit();
    }
  });
  return (
    <div>
      <motion.div className={styles.evaluatorFooter} layout>
        <AnimatePresence>
          {questionIndex > 0 && (
            <motion.button
              key="previous"
              className={styles.previousButton}
              onClick={onPrevious}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              layout
              transition={{
                type: "spring",
                stiffness: 300,
                damping: 25,
              }}
            >
              Previous
            </motion.button>
          )}
        </AnimatePresence>
        {isLastQuestion ? (
          <motion.button
            key="approve-submit"
            className={styles.approvalButton}
            title="ctrl+Enter"
            onClick={onApproveAndSubmit}
            disabled={!approvalValid}
            layout
            whileHover="hover"
            initial="initial"
          >
            <motion.img
              src={tickIcon}
              alt="Tick Icon"
              variants={
                approvalValid
                  ? {
                      initial: { scale: 1 },
                      hover: {
                        scale: 1.2,
                        transition: {
                          type: "spring",
                          stiffness: 300,
                          damping: 20,
                        },
                      },
                    }
                  : {
                      initial: { scale: 1 },
                      hover: { scale: 1 },
                    }
              }
            />
            Approve & Submit
          </motion.button>
        ) : (
          <motion.button
            key="approve-next"
            className={styles.approvalButton}
            title="ctrl+Enter"
            onClick={onApproveAndNext}
            disabled={!approvalValid || isSaving}
            layout
            whileHover="hover"
            initial="initial"
          >
            <motion.img
              src={tickIcon}
              alt="Tick Icon"
              variants={
                approvalValid
                  ? {
                      initial: { scale: 1 },
                      hover: {
                        scale: 1.2,
                        transition: {
                          type: "spring",
                          stiffness: 300,
                          damping: 20,
                        },
                      },
                    }
                  : {
                      initial: { scale: 1 },
                      hover: { scale: 1 },
                    }
              }
            />
            {isSaving ? "Saving..." : "Approve & Next"}
          </motion.button>
        )}
        {evaluationType == EVALUATION_TYPES.QUESTION_WISE_EVALUATION && (
          <motion.div>
          <motion.button
          key="approve-next"
          title="ctrl+Enter"
          className={styles.approvalButton}
          onClick={onApproveAndNext}
          disabled={!approvalValid || isSaving}
          layout
          whileHover="hover"
          initial="initial"
        >
          <motion.img
            src={tickIcon}
            alt="Tick Icon"
            variants={
              approvalValid
                ? {
                    initial: { scale: 1 },
                    hover: {
                      scale: 1.2,
                      transition: {
                        type: "spring",
                        stiffness: 300,
                        damping: 20,
                      },
                    },
                  }
                : {
                    initial: { scale: 1 },
                    hover: { scale: 1 },
                  }
            }
          />
          {isSaving ? "Saving..." : "Approve & Next"}
        </motion.button>
        </motion.div>
        )}
      </motion.div>
    </div>
  );
}

export default EvaluationFooter;
